import { render } from "./VendingMachineByFloor.vue?vue&type=template&id=5a7004c6"
import script from "./VendingMachineByFloor.vue?vue&type=script&lang=js"
export * from "./VendingMachineByFloor.vue?vue&type=script&lang=js"
script.render = render

export default script